/*
 * Copyright (c) 2004-2019 Paul Blacknell. All rights reserved.
 * https://github.com/blacknell
 */

import axios from 'axios';

export const eventLevel = {
    debug: 100,
    info: 200,
    notice: 250,
    warning: 300,
    error: 400,
    critical: 500,
    alert: 550,
    emergency: 600,
};

async function sendClientEvent(level, description, data) {

    const API_EVENT_REQUEST_PROD = '/api/v1/event/log';
    const API_EVENT_REQUEST_LOCAL = 'http://api.sleepylizard.com/api.php?request=event/log';
    const API_AUTHENTICATION_TOKEN = '4NUzB8CmVjzAvgP';

    const restRequestPrefix = window.location.host === 'localhost:3000' ? API_EVENT_REQUEST_LOCAL : API_EVENT_REQUEST_PROD;
    try {
        await axios.post(
            restRequestPrefix + '/' + level + '/' + description,
            {
                data: data,
            },
            {
                headers: {
                    'Accept': 'application/json',
                    'Authentication-Token': API_AUTHENTICATION_TOKEN,
                },
                withCredentials: true,
                timeout: 5000,
            });
    } catch (e) {
        // try and catch any errors and not pass them up
        // we don't care
    }
}

export default sendClientEvent;